import script from "./ScaleToFit.vue?vue&type=script&setup=true&lang=js"
export * from "./ScaleToFit.vue?vue&type=script&setup=true&lang=js"

import "./ScaleToFit.vue?vue&type=style&index=0&id=2f81c6b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f81c6b6"]])

export default __exports__